import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./studentsTour.css";

export function startStudentsPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giới thiệu các vùng chính của trang Học viên: header, lọc dữ liệu, dashboard và bảng danh sách.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="students-header"]',
      title: "Tiêu đề trang",
      description: "Hiển thị số học viên đang hiển thị theo bộ lọc hiện tại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="students-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description: "Mở tour nhanh hoặc tài liệu HTML cho nghiệp vụ quản lý học viên.",
      side: "left",
    },
    {
      selector: '[data-tour="students-filter"]',
      title: "Bộ lọc và thao tác chính",
      description: "Tìm kiếm, lọc theo nhóm điều kiện, thêm mới và import học viên.",
      side: "bottom",
    },
    {
      selector: '[data-tour="students-dashboard"]',
      title: "Mini dashboard",
      description: "Thống kê nhanh số lượng học viên theo trạng thái và phân loại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="students-table"]',
      title: "Bảng danh sách học viên",
      description: "Bấm vào từng dòng để xem chi tiết, chỉnh sửa hoặc thực hiện thao tác hàng loạt.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "students-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
